import { Box, HeaderTemplate, Typography } from 'web-library';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Theme as AugmentedTheme } from '@mui/material';

import { makeStyles } from 'tss-react/mui';
import BreadCrumbs from '../../components/bread-crumbs/BreadCrumbs';
import SchoolCandidatePayment from '../../modules/payment/components/SchoolCandidatePayment';
import { useWOGAA } from '../../hooks/wogaa';

const useStyles = makeStyles()((theme) =>
({
  title: {
    color: theme.color.text.textHeader,
    marginBottom: theme.spacing(6),
  },
  breadCrumbs: {
    [theme.breakpoints.down('md')]: {
      marginTop: theme.spacing(9),
    },
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(9),
    },
  },
}));

const SchoolCandidatePaymentPage = () => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  const { transactionStart } = useWOGAA('myexamsseab-6469');
  transactionStart();
  return (
    <>
      <Box className={classes.breadCrumbs}>
        <BreadCrumbs separator="NextIcon" rootName="Login" />
      </Box>
      <HeaderTemplate>
        <Typography variant="h1" className={classes.title}>
          {t('components->>SchoolCandidatePayment.Title')}
        </Typography>
      </HeaderTemplate>
      <SchoolCandidatePayment />
    </>
  );
};
export default SchoolCandidatePaymentPage;
